{
  "label": "applicazione",
  "name": "Nome",
  "model": {
    "declination": "Gamma",
    "type": "Tipo"
  },
  "versionNumber": "Numero di versione",
  "serialNumber": "Numero di serie",
  "terminalName": "Nome del terminale",
  "windowsUserAccount": "Account Windows dell’utente",
  "sector": "Rete",
  "connectivity": "Connettività",
  "certificate": "Certificato",
  "state": "Stato",
  "states": {
    "activated": "Attivato",
    "deactivated": "Disattivato",
    "registered": "Nuovo"
  },
  "actions": {
    "scheduled": {
      "title": "Azioni in corso?",
      "yes": "Sì",
      "no": "No",
      "error": "Indeterminato"
    }
  },
  "additionalMetadata": {
    "title": "Metadati aggiuntivi",
    "username": "Nome utente",
    "installationDate": "Data di installazione",
    "computerName": "Nome del computer",
    "licenseId": "Numero di licenza : {value}",
    "options": {
      "title": "Opzioni",
      "numericSoftware": {
        "1": "Stazioni remote autorizzate : {value}",
        "2": "Data di scadenza della licenza : {value}"
      }
    }
  },
  "firmwareVersion": "Versione software",
  "updateCertificate": "Aggiornamento del certificato",
  "updateState": {
    "activate": {
      "title": "Attivare",
      "execute": "Attivare l’applicazione",
      "description": "L’applicazione {name} sarà attivata."
    },
    "deactivate": {
      "title": "Disattivare",
      "execute": "Disattivare l’applicazione",
      "description": "L’applicazione {name} sarà disattivata.",
      "warning": "Un’applicazione disattivata non usufruisce più degli aggiornamenti manuali e automatici dei certificati.",
      "error": "Questa applicazione non può essere disattivata perché presenta un’operazione pianificato o in corso."
    }
  },
  "month": "{n} mesi | {n} mesi",
  "year": "{n} anno | {n} anni",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "Non è stata trovata nessuna applicazione.",
  "delete": {
    "execute": "Eliminare l’applicazione",
    "description": "L’applicazione {name} sarà eliminata.",
    "warning": "Anche le operazioni associate all’applicazione saranno eliminate.",
    "error": "Questa applicazione non può essere eliminata perché presenta un’operazione pianificato o in corso."
  },
  "description": {
    "certificateValidityDate": "Data di validità del certificato",
    "communicationProtocol": "Protocollo comunicazione",
    "configurationApplicationDate": "Data di applicazione della configurazione",
    "connectivity": "Connettività",
    "firmwareVersion": "Versione software",
    "firstCommissioningDate": "Data della prima messa in servizio",
    "gsmFrequencyBand": "Banda di frequenza GSM",
    "idCard": "Carta d’identità",
    "lastChange": "Ultima modifica",
    "lastConnection": "Ultima connessione",
    "lastFirmwareUpdate": "Ultimo aggiornamento del firmware",
    "lastRebootDate": "Data dell’ultimo riavvio",
    "mobileNetwork": "Rete mobile",
    "model": "Gamma",
    "name": "Nome",
    "serialNumber": "Numero di serie",
    "state": "Stato",
    "terminalName": "Numero di serie",
    "title": "Descrizione",
    "type": "Tipo",
    "windowsUsername": "Account Windows dell’utente"
  },
  "certificateForm": {
    "expirationDate": "Data di scadenza del certificato",
    "certificateOrigin": "Origine del certificato",
    "lastUpdate": "Ultimo aggiornamento del certificato"
  },
  "operation": {
    "cancelAction": {
      "title": "Annulla l’operazione",
      "confirm": {
        "title": "Annullare questa operazione?",
        "description": "Questa operazione verrà annullata"
      }
    },
    "updateAction": {
      "title": "Aggiornare l’operazione"
    },
    "unitary": "Unitari",
    "campaign": "Campagne"
  },
  "back": "indietro"
}
